/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface StageSyncUpdate {
  id: string;
  name?: string | null;
  color?: string | null;
  description?: string | null;
}
